import React, { useState, useEffect, useContext, useRef } from 'react'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from 'store/rootStore'
import { useSnackbar } from 'notistack'
import { createSupport, updateSupportById, postPhoto } from 'requests/misc'
import { getDealList } from 'requests/cp'
import { getSaleList } from 'requests/sale'
import { getCreditRequestList } from 'requests/fb'
import { getCarList } from 'requests/car'
import {
  moduleList,
  typeList,
  serviceList,
  systemList,
  typeSeoList,
  seoList
} from 'lib/constants'
import { isMobile } from 'lib/utils'
import { getBranches, getUserByToken } from 'requests/auth'
import Lightbox from 'react-image-lightbox'
import {
  DialogContent,
  Grid,
  LinearProgress,
  MenuItem,
  Typography
} from '@material-ui/core'
import { secondaryB } from 'asterX-UIkit/constants/colors'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import DialogAster from 'asterX-UIkit/Dialog/DialogAster'
import DialogTitleCustom from 'asterX-UIkit/Dialog/DialogTitleCustom'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'
import MaskedTextInput from 'asterX-UIkit/Inputs/MaskedTextInput'
import AsterSelect from 'asterX-UIkit/Inputs/AsterSelect'
import AsterButton from 'asterX-UIkit/Buttons/AsterButton'
import ChatModal from './ChatModal'
import ErrorModal from './ErrorModal'
import * as status from 'constants/statuses'
import * as division from 'constants/divisions'
import { domains } from 'constants/domains'

const SearchComponent = ({ module, form, setForm }) => {
  const [loading, setLoading] = useState(false)
  const [answer, setAnswer] = useState([])
  const handleChange = event => {
    const { name, value } = event.target
    setForm(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const handleSearch = async () => {
    setLoading(true)
    if (module === 'Авто') {
      const result = await getCarList({ limit: 10, offset: 0, vin: form.vin })
      setAnswer(
        result?.listCars?.map(item => ({
          vin: item.vin,
          branch: item.branch.name,
          status: item.carStatus.name
        }))
      )
    }
    if (module === 'Авто выкуп') {
      const result = await getDealList({
        limit: 10,
        offset: 0,
        dealId: form.dealId
      })
      setAnswer(
        result?.dealList?.map(item => ({
          branch: item?.branch?.name,
          status: item?.carStatusTrack?.carStatus?.name,
          manager: item?.car?.ropFullName,
          vin: item?.car?.vin
        }))
      )
    }
    if (module === 'Авто продажа') {
      const result = await getSaleList({
        limit: 10,
        offset: 0,
        id: form.dealId
      })
      setAnswer(
        result?.listSales?.map(item => ({
          branch: item?.branch?.name,
          status: item?.saleStatusTrack?.trackStatus?.name,
          manager: item?.saleStatusTrack?.createdByFullname
        }))
      )
    }
    if (module === 'Carfin') {
      const result = await getCreditRequestList(form.iin)
    }
    setLoading(false)
  }
  if (module === 'Авто') {
    return (
      <Grid item container spacing={2}>
        <Grid item xs={8} md={8}>
          <AsterTextField
            fullWidth
            label="VIN"
            name={'vin'}
            value={form.vin || ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4} md={4}>
          <AsterButton
            fullWidth
            color={'positive'}
            onClick={handleSearch}
            disabled={loading || !form.vin || form.vin.length < 6}
            style={{ height: '100%' }}
          >
            Поиск
          </AsterButton>
        </Grid>
        <Grid item xs={12} md={12}>
          {answer.map(item => (
            <Grid
              item
              container
              justify="space-between"
              xs={12}
              md={12}
              style={{
                padding: 12,
                border: '2px solid' + secondaryB,
                borderRadius: 10
              }}
            >
              {Object.values(item).map(value => (
                <span style={{ fontSize: 12 }}>{value || 'Пусто'}</span>
              ))}
            </Grid>
          ))}
        </Grid>
      </Grid>
    )
  }
  if (module === 'Авто выкуп' || module === 'Авто продажа') {
    return (
      <Grid item container spacing={2}>
        <Grid item xs={8} md={8}>
          <AsterTextField
            fullWidth
            label="ID сделки/заявки"
            name={'dealId'}
            type="number"
            value={form.dealId || ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4} md={4}>
          <AsterButton
            fullWidth
            color={'positive'}
            onClick={handleSearch}
            disabled={loading || !form.dealId || form.dealId.length < 1}
            style={{ height: '100%' }}
          >
            Поиск
          </AsterButton>
        </Grid>
        <Grid item xs={12} md={12}>
          {answer.map(item => (
            <Grid
              item
              container
              justify="space-between"
              xs={12}
              md={12}
              style={{
                padding: 12,
                border: '2px solid' + secondaryB,
                borderRadius: 10
              }}
            >
              {Object.values(item).map(value => (
                <span style={{ fontSize: 12 }}>{value || 'Пусто'}</span>
              ))}
            </Grid>
          ))}
        </Grid>
      </Grid>
    )
  }
  if (module === 'Carfin') {
    return (
      <Grid item container spacing={2}>
        <Grid item xs={8} md={8}>
          <AsterTextField
            fullWidth
            label="ИИН"
            name={'iin'}
            value={form.iin || ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4} md={4}>
          <AsterButton
            fullWidth
            color={'positive'}
            onClick={handleSearch}
            disabled={loading || !form.iin || form.iin.length < 12}
            style={{ height: '100%' }}
          >
            Поиск
          </AsterButton>
        </Grid>
      </Grid>
    )
  }

  if (module === 'Сотовая связь') {
    return (
      <Grid item container>
        <AsterTextField
          fullWidth
          label="IMEI"
          name={'imei'}
          value={form.imei || ''}
          onChange={handleChange}
        />
      </Grid>
    )
  }
  return <></>
}

const CreateModal = ({ open, prevForm, onClose }) => {
  const { authStore } = useContext(RootStoreContext)
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState(
    !!prevForm.id
      ? {
          ...prevForm,
          phone: prevForm.phone ? prevForm.phone?.replace('8', '+7') : ''
        }
      : {
          ...prevForm,
          branchCode: jwtDecode(localStorage.getItem('token'))?.branchCode
        }
  )
  const [chat, setChat] = useState(
    prevForm.chat ? JSON.parse(prevForm.chat) : []
  )
  const [isOpen, setIsOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(null)
  const [branchList, setBranchList] = useState([])
  const [userData, setUserData] = useState([])
  const [error, setError] = useState(false)
  const modalRef = useRef(null)
  const currentUser = jwtDecode(localStorage.getItem('token'))

  const handleChange = event => {
    const { name, value } = event.target
    setForm(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handlePaste = event => {
    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items

    Object.values(items).map(item => {
      if (item.kind === 'file') {
        setLoading(true)
        const blob = item.getAsFile()
        if (blob.size > 10000000) {
          enqueueSnackbar('Размер файла не может превышать 10мб')
          setLoading(false)
        } else {
          postPhoto(blob).then(r => {
            setForm(prevForm => ({
              ...prevForm,
              userPhotos: !!form?.userPhotos?.length
                ? [...form.userPhotos, r.fileDownloadUri]
                : [r.fileDownloadUri]
            }))
            setLoading(false)
          })
        }
      }
    })
  }

  const handleAssignSelf = () => {
    setForm(prevState => ({
      ...prevState,
      userUsername: currentUser.sub,
      phone: userData.phone,
      email: userData.email
    }))
  }

  const getDataUser = () => {
    getUserByToken().then(r => setUserData(r))
  }

  useEffect(() => {
    getDataUser()
  }, [])

  const handleUpload = event => {
    const { files } = event.target
    const fileArray = [...files]
    Promise.all(
      fileArray.map(async file => {
        const result = await postPhoto(file)
        return result
      })
    ).then(res => {
      res[0].size > 10000000
        ? enqueueSnackbar('Размер файла не может превышать 10мб')
        : setForm(prevState => ({
            ...prevState,
            userPhotos: [
              ...(form?.userPhotos || []),
              ...res.map(photo => photo.fileDownloadUri)
            ]
          }))
    })
  }

  const isValid = () => {
    if (
      !form.module ||
      (authStore.division === division.ASTERX_DIVISION && !form.type)
    ) {
      enqueueSnackbar('Заполните все поля!', {
        variant: 'error'
      })

      return false
    }

    if (
      [
        'Устройства',
        '1C',
        'Сеть и интернет',
        'Запрос на технику',
        'Сотовая связь',
        'Программное обеспечение',
        'Сотовая связь',
        'Прочее'
      ].includes(form.module)
    ) {
      if (!form.phone || form.phone.length < 10) {
        enqueueSnackbar('Заполните поле Номер!', {
          variant: 'error'
        })

        return false
      }

      if (!form.email || form.email.length < 3) {
        enqueueSnackbar('Заполните поле Email!', {
          variant: 'error'
        })

        return false
      }

      if (!form.description || form.description.length < 3) {
        enqueueSnackbar('Заполните поле Описания!', {
          variant: 'error'
        })

        return false
      }
    }

    if (
      authStore.division === division.HELP_DESK_DIVISION &&
      form.email &&
      !!domains.find(item => form.email.includes(item))
    ) {
      if (
        form.email.substr(0, form.email.indexOf('@')).length < 4 ||
        /^[-*.,:;'#$"</>^&?!+%№]/.test(
          form.email.substr(0, form.email.indexOf('@'))
        )
      ) {
        setError(
          'e-mail адрес должен содержать более 4 символов и начинаться с допустимого символа!'
        )

        return false
      }
    } else if (
      authStore.division === division.HELP_DESK_DIVISION &&
      form.email
    ) {
      setError('Напишите корпоративный e-mail')

      return false
    }

    if (
      authStore.division === division.HELP_DESK_DIVISION &&
      form.type === 'Ошибка'
    ) {
      if (
        !form.userUsername ||
        form.userUsername.length < 4 ||
        !form.userPwd ||
        form.userPwd.length < 4
      ) {
        enqueueSnackbar('Заполните поля Логин и Пароль!', {
          variant: 'error'
        })

        return false
      }

      if (!form.description || form.description.length < 3) {
        enqueueSnackbar('Заполните поле Описания!', {
          variant: 'error'
        })

        return false
      }

      if (!form.userPhotos || form.userPhotos.length < 1) {
        enqueueSnackbar('Прикрепите скриншот ошибки!', {
          variant: 'error'
        })

        return false
      }
    }

    if (
      authStore.division === division.HELP_DESK_DIVISION &&
      form.module === 'Доступы'
    ) {
      if (!form.system) {
        enqueueSnackbar('Заполните поля системы!', {
          variant: 'error'
        })

        return false
      }

      if (!form.phone || form.phone.length < 10) {
        enqueueSnackbar('Заполните номер телефона', {
          variant: 'error'
        })

        return false
      }

      if (!form.email) {
        enqueueSnackbar('Заполните email', {
          variant: 'error'
        })

        return false
      }
    }

    if (
      (authStore.division === division.HELP_DESK_DIVISION &&
        form.type === 'Киоск') ||
      form.type === 'Экран/звук'
    ) {
      if (!form.phone || form.phone.length < 10) {
        enqueueSnackbar('Заполните поля Номер!', {
          variant: 'error'
        })

        return false
      }

      if (!form.description || form.description.length < 3) {
        enqueueSnackbar('Заполните поле Описания!', {
          variant: 'error'
        })

        return false
      }
    }

    if (
      authStore.division === division.ASTERX_DIVISION &&
      form.type === 'Ошибка'
    ) {
      if (!form.userUsername || form.userUsername.length < 4) {
        enqueueSnackbar('Заполните поля Логин!', {
          variant: 'error'
        })

        return false
      }

      if (!form.phone || form.phone.length < 10) {
        enqueueSnackbar('Заполните поля Номер!', {
          variant: 'error'
        })

        return false
      }

      if (!form.description || form.description.length < 3) {
        enqueueSnackbar('Заполните поле Описания!', {
          variant: 'error'
        })

        return false
      }
    }

    if (form.module === 'Авто' && (!form.vin || form.vin.length < 6)) {
      enqueueSnackbar('Заполните поле VIN!', {
        variant: 'error'
      })

      return false
    }

    if (
      (form.module === 'Авто выкуп' || form.module === 'Авто продажа') &&
      (!form.dealId || form.dealId.length < 1)
    ) {
      enqueueSnackbar('Заполните поле ID сделки/заявки!', {
        variant: 'error'
      })

      return false
    }

    if (form.module === 'Carfin' && (!form.iin || form.iin.length < 12)) {
      enqueueSnackbar('Заполните поле ИИН!', {
        variant: 'error'
      })

      return false
    }

    if (form.module === 'СКУД' || form.module === 'Видеонаблюдение') {
      if (!form.phone || form.phone.length < 10) {
        enqueueSnackbar('Заполните номер телефона', {
          variant: 'error'
        })

        return false
      }

      if (!form.email) {
        enqueueSnackbar('Заполните email', {
          variant: 'error'
        })

        return false
      }
    }

    return true
  }

  const handleSave = () => {
    if (!isValid()) return

    const token = localStorage.getItem('token')
    const currentUser = jwtDecode(token)

    setLoading(true)

    if (prevForm.id) {
      updateSupportById(form).then(() => onClose())

      return
    }

    createSupport({
      ...form,
      department: 'ShinhanX',
      status: status.NEW_STATUS,
      createdDate: moment().format(),
      createdBy: currentUser.sub,
      createdByFullname: currentUser.lastName + ' ' + currentUser.firstName
    }).then(() => onClose())
  }

  const getBrancheList = () => {
    getBranches().then(r => setBranchList(r))
  }

  useEffect(() => {
    getBrancheList()
  }, [])

  const access = form.module === 'Доступы'
  const seo = form.module === 'СЭО'

  if (form.type === 'Киоск' || form.type === 'Экран/звук') {
    authStore.division = division.HELP_DESK_DIVISION
  }

  if (form.type === 'Ошибка') {
    authStore.division = division.ASTERX_DIVISION
  }

  return (
    <DialogAster
      id="modal"
      fullScreen={isMobile()}
      onClose={onClose}
      open={open}
      style={{ left: prevForm.id && !isMobile() ? '-224px' : 0 }}
    >
      <DialogTitleCustom onClose={onClose}>
        {form.id ? 'Детали заявки' : 'Создать заявку'} - для {form.department}
      </DialogTitleCustom>
      <DialogContent ref={modalRef}>
        <Grid
          container
          direction={'row'}
          alignItems={'center'}
          spacing={2}
          justify={'center'}
        >
          {loading && (
            <Grid item xs={12} md={12}>
              <LinearProgress />
            </Grid>
          )}
          <Grid item xs={6} md={6}>
            <AsterTextField
              label="Номер заявки"
              fullWidth
              name={'id'}
              disabled
              value={form.id || ''}
            />
          </Grid>
          {access && (
            <Grid item xs={6} md={6}>
              <AsterSelect
                label="Системы"
                fullWidth
                name="system"
                value={form.system || ''}
                onChange={handleChange}
              >
                <MenuItem value={''}>Не выбрано</MenuItem>
                {systemList.filter(Boolean).map(module => (
                  <MenuItem key={module.id} value={module.id}>
                    {module.name}
                  </MenuItem>
                ))}
              </AsterSelect>
            </Grid>
          )}
          {!access && !seo && (
            <Grid item xs={6} md={6}>
              <AsterSelect
                label="Модуль"
                fullWidth
                name="module"
                value={form.module || ''}
                onChange={handleChange}
              >
                <MenuItem value={''}>Не выбрано</MenuItem>
                {moduleList
                  .filter(Boolean)
                  .filter(
                    f => f.division === (form.department || authStore.division)
                  )
                  .map(module => (
                    <MenuItem key={module.id} value={module.id}>
                      {module.name}
                    </MenuItem>
                  ))}
              </AsterSelect>
            </Grid>
          )}

          {seo && (
            <>
              <Grid item xs={6} md={6}>
                <AsterSelect
                  label="Модуль"
                  fullWidth
                  name="module"
                  value={form.module || ''}
                  onChange={handleChange}
                >
                  {seoList.filter(Boolean).map(module => (
                    <MenuItem key={module.id + 'key'} value={module.id}>
                      {module.name}
                    </MenuItem>
                  ))}
                </AsterSelect>
              </Grid>
              <Grid item xs={12} md={12}>
                <AsterSelect
                  label="Тип заявки"
                  fullWidth
                  name="type"
                  value={form.type || ''}
                  onChange={handleChange}
                >
                  <MenuItem value={''}>Не выбрано</MenuItem>
                  {typeSeoList.filter(Boolean).map(type => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </AsterSelect>
              </Grid>
            </>
          )}

          {(form.department || authStore.division) ===
            division.ASTERX_DIVISION &&
            !seo && (
              <>
                <Grid item xs={6} md={6}>
                  <AsterSelect
                    label="Тип заявки"
                    fullWidth
                    name="type"
                    value={form.type || ''}
                    onChange={handleChange}
                  >
                    <MenuItem value={''}>Не выбрано</MenuItem>
                    {typeList.filter(Boolean).map(type => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.name}
                      </MenuItem>
                    ))}
                  </AsterSelect>
                </Grid>
                <Grid item xs={6} md={6}>
                  <AsterSelect
                    fullWidth
                    label="Услуга"
                    name="serviceName"
                    disabled={form.type !== 'Операция'}
                    value={form.serviceName || ''}
                    onChange={handleChange}
                  >
                    <MenuItem value={''}>Не выбрано</MenuItem>
                    {serviceList
                      .filter(
                        item =>
                          item.module === form.module || item.module === null
                      )
                      .map(service => (
                        <MenuItem key={service.id} value={service.id}>
                          {service.name}
                        </MenuItem>
                      ))}
                  </AsterSelect>
                </Grid>
              </>
            )}

          <SearchComponent module={form.module} form={form} setForm={setForm} />
          {(form.department || authStore.division) ===
            division.ASTERX_DIVISION && (
            <>
              <Grid item xs={6} md={6}>
                <AsterTextField
                  fullWidth
                  label="Логин"
                  name={'userUsername'}
                  disabled={form.type === 'Операция'}
                  value={form.userUsername || ''}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <MaskedTextInput
                  fullWidth
                  label="Номер телефона"
                  name={'phone'}
                  value={form.phone || ''}
                  mask={'+7 (999) 999-99-99'}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={10} md={10}>
                <AsterSelect
                  fullWidth
                  label="Филиал"
                  name={'branchCode'}
                  disabled={form.type === 'Операция'}
                  value={form.branchCode || ''}
                  onChange={handleChange}
                >
                  {branchList?.map(elem => (
                    <MenuItem value={elem.code}>{elem.name}</MenuItem>
                  ))}
                </AsterSelect>
              </Grid>

              <Grid item xs={2} md={2}>
                <AsterButton
                  color={'secondary'}
                  onClick={handleAssignSelf}
                  disabled={
                    loading ||
                    (prevForm.status !== status.NEW_STATUS && form.id)
                  }
                  style={{ height: '100%' }}
                >
                  Я
                </AsterButton>
              </Grid>
            </>
          )}

          {(form.department || authStore.division) ===
            division.HELP_DESK_DIVISION && (
            <>
              <Grid item xs={5} md={5}>
                <MaskedTextInput
                  fullWidth
                  label="Номер телефона"
                  name={'phone'}
                  value={form.phone || ''}
                  mask={'+7 (999) 999-99-99'}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={5} md={5}>
                <AsterTextField
                  fullWidth
                  label="Email"
                  name={'email'}
                  value={form.email || ''}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={2} md={2}>
                <AsterButton
                  color={'secondary'}
                  onClick={handleAssignSelf}
                  disabled={
                    loading ||
                    (prevForm.status !== status.NEW_STATUS && form.id)
                  }
                  style={{ height: '100%' }}
                >
                  Я
                </AsterButton>
              </Grid>

              <Grid item xs={12} md={12}>
                <AsterSelect
                  fullWidth
                  label="Филиал"
                  name={'branchCode'}
                  disabled={form.type === 'Операция'}
                  value={form.branchCode || ''}
                  onChange={handleChange}
                >
                  {branchList?.map(elem => (
                    <MenuItem value={elem.code}>{elem.name}</MenuItem>
                  ))}
                </AsterSelect>
              </Grid>

              <ErrorModal
                e={error}
                close={() => setError(false)}
                snackbar={true}
              />
            </>
          )}

          <Grid item xs={10} md={10}>
            <AsterTextField
              label="Описание (вставка картины CTRL+V)"
              fullWidth
              multiline
              rows={4}
              name={'description'}
              value={form.description || ''}
              onChange={handleChange}
              onPaste={handlePaste}
            />
          </Grid>

          <Grid item xs={2} md={2}>
            <AsterButton
              component="label"
              color={'secondary'}
              disabled={
                loading ||
                (form.id &&
                  prevForm.status !== status.NEW_STATUS &&
                  prevForm.status !== status.IN_PROGRESS_STATUS)
              }
              style={{ height: '100%' }}
            >
              <AttachFileIcon />
              <input
                hidden
                accept="image/*"
                multiple
                type="file"
                onChange={handleUpload}
                onPaste={handlePaste}
              />
            </AsterButton>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography variant="caption" display="block" gutterBottom>
              *Размер файла не может превышать 10мб
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} style={{ flexWrap: 'wrap' }}>
            {(form.userPhotos || []).map((photo, index) => (
              <img
                src={photo}
                alt=""
                onClick={() => {
                  setIsOpen(true)
                  setPhotoIndex(index)
                }}
                style={{
                  marginRight: 6,
                  width: 160,
                  height: 80,
                  borderRadius: 12
                }}
              />
            ))}
          </Grid>
          {(form.status === status.NEW_STATUS ||
            form.status === status.IN_PROGRESS_STATUS ||
            !form.id) && (
            <Grid item xs={12} md={12}>
              <AsterButton
                fullWidth
                color={'secondary'}
                disabled={loading}
                onClick={handleSave}
              >
                {prevForm.id ? 'Изменить' : 'Создать'}
              </AsterButton>
            </Grid>
          )}
        </Grid>
        {prevForm.id && (
          <>
            <Grid
              container
              direction={'row'}
              alignItems={'center'}
              spacing={2}
              justify={'center'}
            >
              <Grid item xs={6} md={6}>
                <AsterTextField
                  label="Дата приема"
                  fullWidth
                  name={'inProcessDate'}
                  value={
                    form?.inProcessDate
                      ? moment(form?.inProcessDate).format('DD.MM.YYYY HH:mm')
                      : ''
                  }
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <AsterTextField
                  label="Ответственный"
                  fullWidth
                  name={'adminFullName'}
                  value={form.adminFullname || ''}
                />
              </Grid>
            </Grid>
          </>
        )}
        {prevForm.id &&
          [
            status.EXECUTED_STATUS,
            status.DECLINED_STATUS,
            status.POSTPONED_STATUS
          ].includes(prevForm.status) && (
            <>
              <Grid
                container
                direction={'row'}
                alignItems={'center'}
                spacing={2}
                justify={'center'}
              >
                <Grid item xs={6} md={6}>
                  <AsterTextField
                    label="Дата завершения"
                    fullWidth
                    name={'completedDate'}
                    value={
                      form?.completedDate
                        ? moment(form?.completedDate).format('DD.MM.YYYY HH:mm')
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <AsterTextField
                    label="Статус"
                    fullWidth
                    name={'status'}
                    value={form.status || ''}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <AsterTextField
                    label={
                      [
                        status.EXECUTED_STATUS,
                        status.POSTPONED_STATUS
                      ].includes(prevForm.status)
                        ? 'Описание'
                        : 'Причина отказа'
                    }
                    fullWidth
                    name={'comment'}
                    value={
                      ([
                        status.EXECUTED_STATUS,
                        status.POSTPONED_STATUS
                      ].includes(prevForm.status)
                        ? form.comment
                        : form.reason) || ''
                    }
                  />
                </Grid>
                <Grid item xs={12} md={12} style={{ flexWrap: 'wrap' }}>
                  {(form.adminPhotos || []).map((photo, index) => (
                    <img
                      src={photo}
                      onClick={() => {
                        setIsOpen(true)
                        setPhotoIndex((form.userPhotos || []).length + index)
                      }}
                      style={{
                        marginRight: 6,
                        width: 160,
                        height: 80,
                        borderRadius: 12
                      }}
                    />
                  ))}
                </Grid>
              </Grid>
            </>
          )}
        {isOpen && (
          <Lightbox
            mainSrc={
              ([...(form.userPhotos || []), ...(form.adminPhotos || [])] || [])[
                photoIndex
              ]
            }
            nextSrc={
              ([...(form.userPhotos || []), ...(form.adminPhotos || [])] || [])[
                (photoIndex + 1) %
                  (
                    [...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                    []
                  ).length
              ]
            }
            prevSrc={
              ([...(form.userPhotos || []), ...(form.adminPhotos || [])] || [])[
                (photoIndex +
                  (
                    [...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                    []
                  ).length -
                  1) %
                  (
                    [...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                    []
                  ).length
              ]
            }
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex(
                (photoIndex +
                  (
                    [...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                    []
                  ).length -
                  1) %
                  (
                    [...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                    []
                  ).length
              )
            }
            onMoveNextRequest={() =>
              setPhotoIndex(
                (photoIndex + 1) %
                  (
                    [...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                    []
                  ).length
              )
            }
          />
        )}
      </DialogContent>
      {prevForm.id && (
        <DialogContent
          style={{
            position: 'absolute',
            right: isMobile() ? 0 : -450,
            top: isMobile()
              ? modalRef?.current?.offsetHeight || 0
              : 'calc(50% - 250px)',
            width: isMobile() ? 340 : 400,
            height: 500,
            background: '#fff',
            borderRadius: 10,
            overflow: 'hidden'
          }}
        >
          <ChatModal id={prevForm.id} chat={chat} setChat={setChat} />
        </DialogContent>
      )}
    </DialogAster>
  )
}
export default observer(CreateModal)
